import React from 'react';
import './LegalDisclaimer.css';

function LegalDisclaimer(props) {
  window.addEventListener('storage', () => {
    if (localStorage.getItem('isaccepted') != null) {
      props.setisaccepted(true);
    }
    if (sessionStorage.getItem('isaccepted') != null) {
      localStorage.setItem('isaccepted', '1');
    }
  });
  window.addEventListener('beforeunload', () => {
    localStorage.removeItem('isaccepted');
  });
  return (
    <div
      className="wholeDiv"
      style={{ margin: '8px 48px', padding: '16px 48px' }}
    >
      <div className="heading">DISCLAIMER</div>
      <p>
        The information provided on <span>https://abnca.in </span>(henceforth,
        'this site') is for illustrative purposes only. It must not be relied
        upon or viewed as legal advice on actuarial, taxation, investments or
        legal matters. While the content is accurate as at the date of first
        publication or update, laws, regulations, best practises and investment
        environment changes frequently. Therefore treat all information herein
        as indicative and potentially out-of-date. Specific legal advice from
        qualified and licensed practitioners must always be obtained before
        acting upon any information or commentary provided on this site. Any
        inputs from here may only be used at User's own risk.
      </p>
      <p>
        As per the rules of the Institute of Chartered Accountants of India
        (ICAI) ABNCA is not permitted to solicit work or advertise through this
        site except as permitted by those rules. This site is not intended as a
        medium of solicitation or advertisement. The information here shall not
        be construed as an invitation for an accountant-client, investments
        manager-client or a tax advisor-client relationship. Your use of such
        information does not create any of these 3 relationships.
      </p>
      <p>By visiting this site you acknowledge the following: </p>
      <p>1. you are doing so voluntarily and of your own free will;</p>
      <p>
        2. there has been no advertisement, personal communication,
        solicitation, invitation or inducement of any sort from ABNCA or any of
        our employees or agents for any work by ABNCA or its associates;{' '}
      </p>
      <p>
        3. information on this site is not an invitation for an
        accountant-client, investments manager-client or a tax advisor-client
        relationship with ABNCA or its associates;
      </p>
      <p>
        4. your use of the information on this site does not create the
        aforementioned relationships;
      </p>
      <p>
        5. information on this site cannot constitute a basis of a contract;
      </p>
      <p>
        6. no liability can arise to ABNCA due to any interpretation made or
        action taken based on information on this site by the site visitor
      </p>
      <div className="accept" style={{ marginTop: '16px' }}>
        <span
          className="accept-button"
          style={{ paddingRight: '16px', paddingLeft: '16px' }}
          onClick={() => {
            localStorage.setItem('isaccepted', '1');
            sessionStorage.setItem('isaccepted', '1');
            props.setisaccepted(true);
          }}
        >
          I ACCEPT
        </span>
      </div>
    </div>
  );
}
export default LegalDisclaimer;
